import huangPuUniversityReport from "./huangPuUniversityReport.vue";
export default huangPuUniversityReport;
